import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[scrollEndRoot]',
})
export class ScrollEndRootDirective {
  public el = inject(ElementRef);
}
